module.exports = __webpack_public_path__ + "img/SketchPnga65d7402ef086be4f149e33c6a620188be10ea65881edefe02eb98363613dcc7.b6552eda.png";